export default {
  canBeVoided(creditNoteStatus){
    return creditNoteStatus!=null && creditNoteStatus.code=='INIT'
  },
  canBeDeleted(creditNoteStatus){
    return creditNoteStatus!=null && creditNoteStatus.code=='VOIDED'
  },
  canBeReOpen(creditNoteStatus){
    return creditNoteStatus!=null && creditNoteStatus.code=='VOIDED'
  },
  canBeRefunded(creditNoteStatus){
    return creditNoteStatus!=null && ( creditNoteStatus.code=='INIT' || creditNoteStatus.code=='PARTIALLY_PAID')
  },
}
